/** @format */

/* eslint @typescript-eslint/prefer-nullish-coalescing: "warn" -- Legacy code: do not use as an example. */
import { convertRemToPixels } from '@toucan/client/global/application';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const LIST_ITEM_HEIGHT = '24px';
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const LIST_GAP = '0.4rem';
// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const LIST_PADDING_TOP = '12px';

/**
 * Gets the CSS `display` property. Removes flex if the list is collapsable.
 * @param collapsing If the product box can be collapsed
 * @returns CSS `display`
 */
export const getDisplay = (collapsing: boolean) => {
    return collapsing ? 'initial' : 'flex';
};

/**
 * Gets the CSS `height` property for the component. This is based on a fully maxed out list.
 * This ensures every product box in a non collapsing card layout takes up the same height
 * @param isCollapsable If the product box can be collapsed
 * @param maxItemsPerColumn The maximum amount of items to display on a single column
 * @returns CSS `height`
 */
export const getMaxHeight = (
    isCollapsable?: boolean,
    maxItemsPerColumn?: number
) => {
    if (isCollapsable || !maxItemsPerColumn) {
        return '0';
    }

    const listHeight = (() => {
        const itemsHeight = parseFloat(LIST_ITEM_HEIGHT) * maxItemsPerColumn;

        const gapHeight =
            convertRemToPixels(LIST_GAP) * Math.max(maxItemsPerColumn - 1, 0);

        return itemsHeight + gapHeight + LIST_PADDING_TOP;
    })();

    return `${listHeight}px`;
};
